var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYillowLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 498.1 108.5",
    style: {
      enableBackground: "new 0 0 498.1 108.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#016BFF;}\n\t.st1{fill:#006AFF;}\n\t.st2{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000165921119326878852340000015630903357730655159_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M476.7,106.1h-19.6c-3.9-11.9-7.5-23.8-11-35.8c-3.5,12-7.4,23.9-11.2,35.8h-20 c-7.2-22.2-14.3-44.5-21.5-66.8c1-0.3,18.4-0.5,21.5-0.2c3.9,13,8,25.9,11.6,39.4c2-6.8,3.9-13.4,5.9-19.9c2-6.5,4.1-13,6.2-19.5 h15.9c4.1,13,8.3,25.9,11.8,39.4c4-13.3,7.8-26.4,11.7-39.4h20.1C490.9,61.6,483.8,83.8,476.7,106.1L476.7,106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.3,37.3c12.1,0.3,21.6,4.3,28.9,12.8c4.9,5.8,7.6,12.5,8.1,20.1c0.6,8.2-1.3,15.7-5.9,22.5 c-5.6,8.2-13.5,13.2-23.3,15c-7.5,1.4-14.8,0.7-21.8-2.4c-12-5.3-19.3-14.5-21.1-27.5c-1.5-10.9,1.3-20.6,8.8-28.8 c5.3-5.9,12-9.5,19.8-11C351.3,37.6,353.8,37.5,355.3,37.3L355.3,37.3z M371.5,72.4c0.1-2-0.4-4.5-1.4-6.8 c-2.7-5.8-7.2-9.2-13.7-9.3c-6.6-0.1-11.4,3.1-14.1,9.2c-2.1,4.8-2.1,9.7-0.1,14.5c4.2,10.3,17.6,12.7,25,4.7 C370.2,81.4,371.5,77.4,371.5,72.4L371.5,72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.3,3.8h21.6v102.3h-21.6V3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M309.3,106.2h-21.4c-0.3-0.9-0.4-100.3-0.1-102.3h21.4C309.5,4.8,309.6,103.8,309.3,106.2L309.3,106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.5,39.2h21.6v66.9h-21.5C212.3,105.2,212.2,41.7,212.5,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.2,5.6c6.1-0.1,12.3,4.7,12.4,12.3c0,6.8-5.6,12.2-12.5,12.2c-6.8,0-12.3-5.6-12.3-12.4 C210.9,11.1,216.5,5.6,223.2,5.6L223.2,5.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "0.2,39 31.2,39 49.3,62.5 67.6,39 98.3,39 63.3,79.4 63.3,108.5 35.3,108.5 35.3,79.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "63.3,79.4 63.3,108.4 98.3,108.5 98.3,39 98.3,39  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0.3,39.1 0,108.2 35.3,108.3 35.3,79.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "49.3,62.5 67.6,39 98.3,39 50.1,0 0.3,38.7 0.3,39 31.2,39  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.5,70.6v37.9H139V69L106.4,1.6h26.1l22,49.6l20.8-49.6h25.1L167.5,70.6L167.5,70.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYillowLogo);
export default __webpack_public_path__ + "static/media/yillow-logo.78698ddba445fa2dd37338ab70848f19.svg";
export { ForwardRef as ReactComponent };